import React, { Fragment, useState, useEffect } from "react";
import { Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Typography, Grid } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import global from "../../images/global.svg";
import Skeleton from "@mui/material/Skeleton";
import { withStyles } from "@mui/styles";
import Divider from "@mui/material/Divider";
import imagen1 from "../../images/publicidad_1.png";
import imagen2 from "../../images/publicidad_2.jpg";
import imagen3 from "../../images/publicidad_3.png";

const Image = styled("img")({
  width: "100%",
});

function SkeletonChildrenDemo(props) {
  const { loading = false, imagen, url, classes } = props;

  return (
    <div className={classes.publicidad}>
      {loading ? (
        <Skeleton variant="rectangular" width="100%">
          <div style={{ paddingTop: "57%" }} />
        </Skeleton>
      ) : (
        <Link
          href={url}
          target="_blank"
          rel="noopener"
          color="inherit"
          underline="none"
        >
          <Image src={imagen} alt="" />
        </Link>
      )}
    </div>
  );
}

SkeletonChildrenDemo.propTypes = {
  loading: PropTypes.bool,
  imagen: PropTypes.string,
  url: PropTypes.string,
};

const styles = (theme) => ({
  wrapper: {
    marginTop: "100px",
    background: "#fff",
    maxWidth: "1200px",
    marginLeft: "auto",
    marginRight: "auto",

    [theme.breakpoints.up("sm")]: {
      paddingLeft: "24px",
      paddingRight: "24px",
    },
  },

  titulo: {
    fontSize: "4rem !important",
    lineHeight: "1.25 !important",
    fontWeight: "700 !important",

    marginBottom: "40px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "3rem !important",
    },
  },

  tituloAnuncio: {
    fontSize: "4rem !important",
    lineHeight: "1.25 !important",
    fontWeight: "700 !important",

    marginBottom: "40px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "3rem !important",
    },
  },

  centrarSx: {
    textAlign: "right",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },

  paddingSx: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: "20px !important",
      marginRight: "20px !important",
    },
  },

  publicidad: {
    display: "flex",
    alignItems: "center",
  },

  subtitulos: {
    lineHeight: "1.75 !important",
    fontWeight: "400 !important",
    fontSize: "1rem !important",
    paddingTop: "20px",
    marginLeft: "30px",
  },

  contenedorAnuncio: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  container: {
    marginTop: theme.spacing(6),
  },
});

function Anuncios(props) {
  const { classes, theme, width, errors, inicio, messages } = props;
  return (
    <Fragment>
      <div
        className={classNames("lg-p-top crossfade", classes.wrapper)}
        ref={inicio}
      >
        <Grid container spacing={12}>
          <Grid item xs={12}>
            <LazyLoadImage
              alt="IMAR Sistemas"
              height="100%"
              src={global} // use normal <img> attributes as props
              width="100%"
              effect="opacity"
              delayMethod="debounce"
              style={{ borderRadius: "25px" }}
            />
          </Grid>

          <Grid item xs={12} direction="row" className={classes.paddingSx}>
            <Grid container spacing={12}>
              <Grid item xs={12} md={6}>
                <Typography
                  className={[classes.tituloAnuncio, classes.centrarSx]}
                >
                  IMAR Sistemas
                </Typography>

                <Typography
                  variant="h5"
                  className={[classes.centrarSx]}
                  sx={{ marginBottom: "10px" }}
                >
                  {messages.expertos}
                </Typography>

                <Typography className={[classes.centrarSx, classes.subtitulos]}>
                  {messages.texto_productos}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container direction="row">
                  <Grid item xs={5} md={4}>
                    <Typography className={classes.titulo}>14</Typography>
                  </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ border: "1px" }}
                  ></Divider>
                  <Grid item xs={7} md={8}>
                    <Typography className={classes.subtitulos}>
                      {messages.texto_market}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container direction="row">
                  <Grid item xs={5} md={4}>
                    <Typography className={classes.titulo}>29</Typography>
                  </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ border: "1px" }}
                  ></Divider>
                  <Grid item xs={7} md={8}>
                    <Typography className={classes.subtitulos}>
                      {messages.texto_estados}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container direction="row">
                  <Grid item xs={5} md={4}>
                    <Typography className={classes.titulo}>1700</Typography>
                  </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ border: "1px" }}
                  ></Divider>
                  <Grid item xs={7} md={8}>
                    <Typography className={classes.subtitulos}>
                      {messages.texto_empresas}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container direction="row">
                  <Grid item xs={5} md={4}>
                    <Typography className={classes.titulo}>3500</Typography>
                  </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ border: "1px" }}
                  ></Divider>
                  <Grid item xs={7} md={8}>
                    <Typography className={classes.subtitulos}>
                      {messages.texto_usuarios}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4} className={classes.contenedorAnuncio}>
            <SkeletonChildrenDemo
              classes={classes}
              imagen={imagen1}
              url={
                "https://www.imarsistemas.com/auditorias-electronicas-de-comercio-exterior/"
              }
            />
          </Grid>
          <Grid item xs={12} md={4} className={classes.contenedorAnuncio}>
            <SkeletonChildrenDemo
              classes={classes}
              imagen={imagen2}
              url={"https://bado.mx/"}
            />
          </Grid>
          <Grid item xs={12} md={4} className={classes.contenedorAnuncio}>
            <SkeletonChildrenDemo
              imagen={imagen3}
              classes={classes}
              url={"https://www.imarsistemas.com/pedimento-empresarial/"}
            />
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
}

Anuncios.propTypes = {
  classes: PropTypes.object,
  errors: PropTypes.object.isRequired,
  inicio: PropTypes.object.isRequired,
  width: PropTypes.string,
  theme: PropTypes.object,
  messages: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Anuncios);
